import React from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  StyleProp,
  ViewStyle,
} from "react-native";

export const StarFilled: React.FC = () => {
  return (
    <svg width="33.417" height="32.002" viewBox="0 0 33.417 32.002">
      <path
        d="M48.989,785.531a2.263,2.263,0,0,0-2.151,1.56l-2.913,8.92-9.384.014a2.263,2.263,0,0,0-1.329,4.092l7.583,5.528-2.886,8.929a2.263,2.263,0,0,0,3.481,2.529l7.6-5.5,7.6,5.5a2.263,2.263,0,0,0,3.481-2.529l-2.886-8.929,7.583-5.528a2.263,2.263,0,0,0-1.329-4.092l-9.384-.014-2.913-8.92a2.263,2.263,0,0,0-2.151-1.56Z"
        transform="translate(-32.281 -785.531)"
        fill="#ff3000"
      />
    </svg>
  );
};

export const Star: React.FC = () => {
  return (
    <svg width="33.417" height="32.002" viewBox="0 0 33.417 32.002">
      <g transform="translate(-32.281 -785.531)" fill="none">
        <path
          d="M48.989,785.531a2.263,2.263,0,0,0-2.151,1.56l-2.913,8.92-9.384.014a2.263,2.263,0,0,0-1.329,4.092l7.583,5.528-2.886,8.929a2.263,2.263,0,0,0,3.481,2.529l7.6-5.5,7.6,5.5a2.263,2.263,0,0,0,3.481-2.529l-2.886-8.929,7.583-5.528a2.263,2.263,0,0,0-1.329-4.092l-9.384-.014-2.913-8.92a2.263,2.263,0,0,0-2.151-1.56Z"
          stroke="none"
        />
        <path
          d="M 48.98924255371094 787.0308227539062 C 48.65811157226562 787.0308227539062 48.36661148071289 787.2421875 48.26386260986328 787.556884765625 L 45.01324081420898 797.5098876953125 L 34.54312133789062 797.5255737304688 C 34.21187973022461 797.5261840820312 33.92059326171875 797.7381591796875 33.81832885742188 798.0529174804688 C 33.716064453125 798.3677368164062 33.82719421386719 798.71044921875 34.09469223022461 798.9054565429688 L 42.55581283569336 805.0728759765625 L 39.33526229858398 815.0355224609375 C 39.23345184326172 815.3504028320312 39.34505081176758 815.6928100585938 39.61333084106445 815.8876953125 C 39.77875137329102 816.0079345703125 39.94831085205078 816.033203125 40.06143188476562 816.033203125 C 40.22326278686523 816.033203125 40.3780632019043 815.9830322265625 40.50900268554688 815.8882446289062 L 48.98924255371094 809.74658203125 L 57.46942138671875 815.88818359375 C 57.6004524230957 815.9830322265625 57.75525283813477 816.033203125 57.91709136962891 816.033203125 C 58.03020095825195 816.033203125 58.19975280761719 816.0079345703125 58.36554336547852 815.887451171875 C 58.63345336914062 815.6928100585938 58.74505233764648 815.3504028320312 58.64323043823242 815.0354614257812 L 55.42280197143555 805.0728759765625 L 63.88367080688477 798.9055786132812 C 64.15132141113281 798.71044921875 64.262451171875 798.3677978515625 64.16021728515625 798.0530395507812 C 64.05790710449219 797.7381591796875 63.7666015625 797.5261840820312 63.43578338623047 797.5255737304688 L 52.96527099609375 797.5098876953125 L 49.7146110534668 787.5567626953125 C 49.61189270019531 787.2421875 49.32039260864258 787.0308227539062 48.98924255371094 787.0308227539062 M 48.98924255371094 785.5308227539062 C 49.96833038330078 785.5308227539062 50.83660125732422 786.160400390625 51.14052200317383 787.0911865234375 L 54.05388259887695 796.0115356445312 L 63.43802261352539 796.0255737304688 C 64.41706848144531 796.02734375 65.28422546386719 796.6581420898438 65.58680725097656 797.5895385742188 C 65.88932037353516 798.5208740234375 65.55862426757812 799.5407104492188 64.76737976074219 800.1176147460938 L 57.18421173095703 805.6451416015625 L 60.07051086425781 814.5740966796875 C 60.37160110473633 815.5054321289062 60.03948974609375 816.5253295898438 59.24722290039062 817.1009521484375 C 58.45552444458008 817.6765747070312 57.38309478759766 817.6776123046875 56.58967208862305 817.1030883789062 L 48.98924255371094 811.5986328125 L 41.38883972167969 817.1030883789062 C 40.59565353393555 817.6774291992188 39.52325439453125 817.6766967773438 38.73128128051758 817.1009521484375 C 37.93902206420898 816.5253295898438 37.60690307617188 815.5054321289062 37.90799331665039 814.5740966796875 L 40.79439163208008 805.6451416015625 L 33.21112823486328 800.1176147460938 C 32.41989135742188 799.5407104492188 32.08920288085938 798.5208740234375 32.39169311523438 797.5895385742188 C 32.69429016113281 796.6581420898438 33.56134033203125 796.02734375 34.54041290283203 796.0255737304688 L 43.92463302612305 796.0115356445312 L 46.83798217773438 787.0911865234375 C 47.14191055297852 786.160400390625 48.01018142700195 785.5308227539062 48.98924255371094 785.5308227539062 Z"
          stroke="none"
          fill="#b6b6b6"
        />
      </g>
    </svg>
  );
};

export type RatingInputProps = {
  containerStyle?: StyleProp<ViewStyle>;
  value?: number;
  onChange: (value: number) => void;
};

export const RatingInput: React.FC<RatingInputProps> = ({
  containerStyle,
  value,
  onChange,
}) => {
  return (
    <View style={[styles.root, containerStyle]}>
      <TouchableOpacity onPress={() => onChange(1)}>
        {value && value >= 1 ? <StarFilled /> : <Star />}
      </TouchableOpacity>
      <TouchableOpacity onPress={() => onChange(2)}>
        {value && value >= 2 ? <StarFilled /> : <Star />}
      </TouchableOpacity>
      <TouchableOpacity onPress={() => onChange(3)}>
        {value && value >= 3 ? <StarFilled /> : <Star />}
      </TouchableOpacity>
      <TouchableOpacity onPress={() => onChange(4)}>
        {value && value >= 4 ? <StarFilled /> : <Star />}
      </TouchableOpacity>
      <TouchableOpacity onPress={() => onChange(5)}>
        {value && value >= 5 ? <StarFilled /> : <Star />}
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
  },
});
